/* eslint-disable react/button-has-type */
/* eslint-disable jsx-a11y/control-has-associated-label */
import { WHATSAPP_URL } from "constants/index";
import CustomLink from "@Components/CustomLink";
// import { gtagEventEmitter } from "helpers/CommonFunctions/gtagEventEmitter";
import styles from "./GetHelpBannerV2.module.scss";
import WhatsAppIcon from "@Icons/WhatsAppIcon";
import gtagEventEmitter from "helpers/gtagEventEmitter";
import { openLeadFormModal } from "@Components/LeadFormModal/data/leadFormReducer";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { AppState } from "@Store/index";
import handleLeadAPICall from "@Components/LeadFormV2/utils/handleLeadAPICall";
import useIsHappyFlow from "hooks/useIsHappyFlow";
import { useHistory } from "hooks/useHistory";
import useTranslationHook from "hooks/useTranslationHook";
import config from "@Config/index";
import WechatGreenOutline from "@Icons/WechatGreenOutline";
import wrapperHOC from "@Utils/wrapperHOC";
import getWeComUrlBasedOnSource, {
  HK_WEIXIN_DWEB,
  HK_WEIXIN_MWEB,
} from "helpers/getWeComUrlBasedOnSource";
import { APP_EVENTS } from "@Utils/webApputils/analyticEvents";
import { logAppEvent } from "@Utils/appAnalytics";
import { useEffect, useState } from "react";
import useIsDesktop from "hooks/useIsDesktop";

const GetHelpBannerV2 = ({ isDesktop: isDesktopProp = false }: any): JSX.Element => {
  const dispatch = useDispatch();
  const isHappyFlow = useIsHappyFlow();
  const history = useHistory();
  const isDesktopHook = useIsDesktop();
  const isDesktop = isDesktopProp || isDesktopHook;
  const [weChatSupportRedirectTo, setWeChatSupportRedirectTo] = useState(
    isDesktop ? HK_WEIXIN_DWEB : HK_WEIXIN_MWEB,
  );

  const { isLFOneFilled, isLeadFormFilled, personalDetails, getHelpClicked, region, filters } =
    useSelector(
      ({ leadFormModal, userHistory, searchPageData }: AppState) => ({
        isLFOneFilled: leadFormModal.isLFOneFilled,
        isLeadFormFilled: leadFormModal.isLeadFormFilled,
        openingSource: leadFormModal.openingSource,
        personalDetails: leadFormModal.personalDetails,
        getHelpClicked: userHistory.getHelpClicked,
        filters: searchPageData.filters,
        region: searchPageData.region,
      }),
      shallowEqual,
    );

  const isGetHelpClicked = isHappyFlow && getHelpClicked.includes(region?.canonical_name);

  const handleGetHelpClick = () => {
    gtagEventEmitter({ action: "get_help_button_clicked", category: "search_page" });

    logAppEvent({
      eventName: APP_EVENTS.LEAD_CTA_CLICKED,
      payload: {
        cta_name: "get_help",
        screen_name: "",
        section_name: "",
      },
    });

    (async () => {
      if (isHappyFlow && isLFOneFilled) {
        await handleLeadAPICall({
          dispatch,
          region,
          inventory: {},
          isLeadFormFilled,
          inModal: true,
          openingSource: "get_help",
          formData: personalDetails,
          isLFOneFilled,
          filters,
          history,
          isDesktop,
        });
      }
      if (!isLFOneFilled || !isHappyFlow) {
        dispatch(
          openLeadFormModal({
            inventory: {},
            inModal: true,
            leadFormPage: 1,
            openingSource: "get_help",
          }),
        );
      }
    })();
  };

  const { t } = useTranslationHook();
  const stuck_somewhere = t("searchpage.searchlist.gethelpbannerv2.stucksomewhere");
  const chat_expert_text = t("searchpage.searchlist.gethelpbannerv2.chatwithexpert");
  const expert_help_text = t("searchpage.searchlist.gethelpbannerv2.experthelptext");

  useEffect(() => {
    const { URLDweb, URLMweb } = getWeComUrlBasedOnSource();
    setWeChatSupportRedirectTo(isDesktop ? URLDweb : URLMweb);
  }, [isDesktop]);

  return !isGetHelpClicked ? (
    <>
      {isDesktop ? (
        <div className={styles.desktopBannerContainer}>
          <div className={styles.messagesContainer}>
            <div className={styles.radialGradient} id="grad" />
            <p className={styles.bannerHeading}>
              <span className={styles.headingHighlight}> {stuck_somewhere}&nbsp;</span>
              <span>{chat_expert_text}</span>
            </p>
            <div className={styles.bannerSubheading}>{expert_help_text}</div>
          </div>
          <div className={styles.getHelpCTA}>
            <button
              className={styles.getHelpButton}
              onClick={handleGetHelpClick}
              data-testid="searchPage-expertConnect-getHelp-button"
            >
              {t("searchpage.searchlist.gethelpbannerv2.gethelp")}
            </button>
          </div>
        </div>
      ) : (
        <div className={styles.bannerContainer}>
          <div className={styles.radiantGradient} />
          <div>
            <p className={styles.bannerHeading}>
              <span className={styles.headingHighlight}>{stuck_somewhere}&nbsp;</span>
              <span>{chat_expert_text}</span>
            </p>
            <div className={styles.bannerSubheading}>
              {t("searchpage.searchlist.gethelpbannerv2.studentaccommodationhelp")}
            </div>
            <div className={styles.getHelpCTA}>
              {config.IS_CHINA_APP ? (
                <CustomLink
                  href={weChatSupportRedirectTo}
                  target="_blank"
                  rel="noreferrer"
                  isExternal
                  className={styles.whatsappBtn}
                  dataTestId="mobile-searchPage-expertConnect-wechat-button"
                >
                  <WechatGreenOutline height={22} width={22} />
                </CustomLink>
              ) : (
                <CustomLink
                  href={WHATSAPP_URL}
                  target="_blank"
                  rel="noreferrer"
                  isExternal
                  className={styles.whatsappBtn}
                  dataTestId="mobile-searchPage-expertConnect-whatsApp-button"
                >
                  <WhatsAppIcon height="22" width="22" fill="#25D366" />
                </CustomLink>
              )}
              <button
                className={styles.getHelpButton}
                onClick={handleGetHelpClick}
                data-testid="mobile-searchPage-expertConnect-getHelp-button"
              >
                {t("searchpage.searchlist.gethelpbannerv2.gethelp")}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  ) : (
    <></>
  );
};

export default wrapperHOC(GetHelpBannerV2, {
  componentName: "GetHelpBannerV2-SearchListDesktop-SearchPage",
  showForChina: true,
  showForWhiteLable: false,
});
